<div class="saved-carts-list-actions-cell-container row no-gutters">
  <div class="col-6 h-100">
    <button
      class="w-100 border-0 rounded-0 bg-white my-auto saved-cart-list-restore-container"
      mat-icon-button
      (click)="onRestoreSavedCartModal()"
    >
      <mat-icon
        matBadge="+"
        matBadgeSize="small"
        matTooltip="{{ 'buttonTooltip.saveCart.restoreCart' | cxTranslate }}"
        [matTooltipPosition]="'below'"
        matTooltipClass="icon-tooltip"
        aria-label="displays a tooltip in bottom"
        class="material-icons-sharp light restore-cart-cell"
        [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
        >shopping_cart</mat-icon
      >
    </button>
  </div>
  <div class="col-6 h-100">
    <button
      class="w-100 border-0 rounded-0 bg-white my-auto saved-cart-list-delete-container"
      mat-icon-button
      (click)="onDeleteSavedCartModal()"
    >
      <mat-icon
        matTooltip="{{ 'buttonTooltip.saveCart.deleteEntry' | cxTranslate }}"
        [matTooltipPosition]="'below'"
        matTooltipClass="icon-tooltip"
        aria-label="displays a tooltip in bottom"
        class="material-icons light delete-cart-cell"
        [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
        >delete_outline</mat-icon
      >
    </button>
  </div>
</div>
